<template>
    <b-row class="slide-body bc-color">
        <b-row >             
            <b-row align-h="center" >                  
                <b-img align="bottom" src="@/images/slide22-tronic.png" fluid></b-img>               
            </b-row>
        </b-row>                
    </b-row>
</template>

<script>
import {mapState} from 'vuex';

export default { 
    props:['lang'],   
    computed: {
        ...mapState(['showMenu']),
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
    },
    created(){
        this.$i18n.locale=this.lang;
    }     
}
</script>


<style scoped>
    .row{
        margin-left: 0px;
        margin-right: 0px;  
        width: 100%; 
    }
    
    .bc-color{
        background: #ffffff;
    }
</style>